import branchBar from './modules/branch-bar';
import $ from 'jquery';
import Mustache from 'mustache';
import cycle2 from 'jquery.cycle2';
import accordions from './modules/accordions';
import './sopimus/index';

global.$ 	    = $;
global.jQuery   = $;
global.Mustache = Mustache;

require('../static/libs/jquery.cookie');
require('./global.js');
require('./libs.js');
require('./searches.js');
require('./form-helper.js');
require('./megasearch.js');
//require('./financeCalc');

import financeCalculator from './financeCalc';

/*
* jquery-match-height 0.7.0 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/

!function(t){'use strict';'function'==typeof define&&define.amd?define(['jquery'],t):'undefined'!=typeof module&&module.exports?module.exports=t(require('jquery')):t(jQuery)}(function(t){var e=-1,o=-1,i=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),n=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-i(e.css('margin-top')),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(n-a))<=o?r[r.length-1]=s.add(e):r.push(e),n=a}),r},n=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return'object'==typeof e?t.extend(o,e):('boolean'==typeof e?o.byRow=e:'remove'===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=n(e);if(o.remove){var i=this;return this.css(o.property,''),t.each(r._groups,function(t,e){e.elements=e.elements.not(i)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version='0.7.0',r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=i,r._parseOptions=n,r._apply=function(e,o){var s=n(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),d=h.parents().filter(":hidden");return d.each(function(){var e=t(this);e.data('style-cache',e.attr('style'))}),d.css('display','block'),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css('display');'inline-block'!==o&&'flex'!==o&&'inline-flex'!==o&&(o='block'),e.data('style-cache',e.attr('style')),e.css({display:o,'padding-top':'0',
'padding-bottom':'0','margin-top':'0','margin-bottom':'0','border-top-width':'0','border-bottom-width':'0',height:'100px',overflow:'hidden'})}),l=a(h),h.each(function(){var e=t(this);e.attr('style',e.data('style-cache')||'')})),t.each(l,function(e,o){var a=t(o),n=0;if(s.target)n=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),i=e.css("display");"inline-block"!==i&&"flex"!==i&&'inline-flex'!==i&&(i='block');var a={
display:i};a[s.property]="",e.css(a),e.outerHeight(!1)>n&&(n=e.outerHeight(!1)),o?e.attr('style',o):e.css('display','')})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||('border-box'!==e.css('box-sizing')&&(o+=i(e.css('border-top-width'))+i(e.css('border-bottom-width')),o+=i(e.css('padding-top'))+i(e.css('padding-bottom'))),e.css(s.property,n-o+'px'))})}),d.each(function(){var e=t(this);e.attr('style',e.data('style-cache')||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t('html').outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t('[data-match-height], [data-mh]').each(function(){var o=t(this),i=o.attr('data-mh')||o.attr('data-match-height');i in e?e[i]=e[i].add(o):e[i]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(i,a){if(a&&'resize'===a.type){var n=t(window).width();if(n===e)return;e=n;
}i?-1===o&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi),t(window).bind('load',function(t){r._update(!1,t)}),t(window).bind('resize orientationchange',function(t){r._update(!0,t)})});

global.navigation = (function(){
	var nav = {};

	nav.toggle = function(section, elem) {
			//If the clicked item is active we will hide it
			if ( elem.hasClass('active') || elem.hasClass('close') ) {
      	//Hide what is currently open and remove active classes from parents etc
      	$('html').css('overflow', 'auto');
      	elem.removeClass('active');
      	$sectionSelectionItem.removeClass('active');
      	$menuSectionParent.removeClass('active');
      	$menuSectionParent.find('section.active').removeClass('active');
      	$sectionSelectionItem.find('.active').removeClass('active');
      	$('body').removeClass('menu-section-open');
      	if ( section == '#navigation' ) {
      		$('body').addClass('main-nav-hidden');
      	}
      } else {
      	$('html').css('overflow', 'hidden');
				//If the clicked is not active we will first remove others from their active state
				$sectionSelectionItem.removeClass('active');
				$menuSectionParent.find('section.active').removeClass('active');
				$sectionSelectionItem.find('.active').removeClass('active');

        //Make sure the parent knows something is active
        $menuSectionParent.addClass('active');

				//Lets make the section we want active
				$(section).addClass('active');
				elem.addClass('active');

				//When a section is open I want to hide main and footer to remove scrolls
				if ( section != '#navigation' ) {
					$('body').addClass('menu-section-open');
				} else {
					$('body').removeClass('menu-section-open');
					$('body').removeClass('main-nav-hidden');
				}

				if ( section == '#megasearch' ) {
					$('#megasearch input[name=search]').focus();
					if ( $.cookie('megasearchTerms') && $.cookie('megasearchTerms') != '' ) {

						megasearch.search( $.cookie('megasearchTerms') );

						$('#megasearch input[name=search]').val( $.cookie('megasearchTerms') );
					}
				}

				if ( section == '#service' && !$('#service').hasClass('loaded') ) {
					//$('.lazy').lazyload();
					$('#service').addClass('loaded');
				}
			}
		};

	//Navigation
	nav.init = function() {
		//On huge screens the navigation is active on default
		if (parseInt(windowWidth) > 1264) {
			$('nav ul.sections li.navigation a').addClass('active');
		}

		if (document.getElementById('main-navigation')) {
			document.body.classList.add('navigation-exists');

			//Hide navigation if on a campaign page
			if (document.querySelector('.campaign-page') && parseInt(windowWidth) > 1264) {
				navigation.toggle('#navigation', $('li.navigation a'));
			}
    }

		$sectionSelectionItem.on('click', 'a', function(e){
			//Defines the id of the section the user clicked
			var section = $(this).attr('href');
			if(section.indexOf('#') > -1){
				e.preventDefault();
				navigation.toggle(section, $(this));
			}
		});

		// Open navi links outside nav (for example "Log in" link)
		$('.external-navi-link').click(function(e){
			e.preventDefault();
			$sectionSelectionItem.find('a[href="'+$(this).attr('href')+'"]').click();
		});


        // Open club login if login failed
        if ($('#login-failed').length) {
        	navigation.toggle('#club', $('li.club a'));
        	$('#login-failed').remove();
        }
        if ($('#login-failed-clubpage').length) {
        	$('.heading a.login').hide();
        	$('.login-form').show();
        	$('#login-failed-clubpage').remove();
        }

		//Frontpage search opens megasearch
		$('.search-input').click(function(e){
			navigation.toggle('#megasearch', $('li.megasearch a'));
			$('html').css('overflow', 'hidden');
		});

		$('.section-title .close').click(function(e){
			e.preventDefault();
			navigation.toggle('#navigation', $('li.navigation a'));
		});

		//Sub level
		$mainNavItem.on('click', 'a', function(e){
			if ($(this).parent().hasClass('children')) {
				e.preventDefault();
				$('.navigation-sub-level .page').removeClass('active');
				var pageClass = $(this).data('page-class');
				$('.'+pageClass).addClass('active');
				$navigations.addClass('animate');
				$navigations.addClass('sub');
			}
		});

		$subNavItem.on('click', 'a', function(e){
			if ($(this).parent().hasClass('children')) {
				e.preventDefault();

				$('.navigation-last-level .page').removeClass('active');
				var pageClass = $(this).data('page-class');
				$('.'+pageClass).addClass('active');
				$navigations.addClass('animate');
				$navigations.addClass('last');
			}

		});

		//Go to main level of nav
		$('.navigation-sub-level .back').bind('touchstart touchend touchmove click', function(e){
			e.preventDefault();
			var $this = $(this);
			$navigations.addClass('animate');
			$navigations.removeClass('sub');
			setTimeout(function(){
				$this.parent().parent().removeClass('active');
			}, 400);
		});
		$('.navigation-last-level .back').bind('touchstart touchend touchmove click', function(e){
			e.preventDefault();
			var $this = $(this);
			$navigations.addClass('animate');
			$navigations.removeClass('last');
			$navigations.addClass('sub');
			setTimeout(function(){
				$this.parent().parent().removeClass('active');
			}, 400);
		});

		//Show carsearch
		$('.navigation .carsearch, #main-navigation .car-search').on('click', 'a', function(e){
			if (searchPage) {
				e.preventDefault();
				$('body').removeClass('main-nav-hidden');
				$('#main-navigation .menu-sections').addClass('active');
				$('#navigation').addClass('active');
				$('.navigation-sub-level').hide();
				$('.navigation-last-level').hide();
				$('.filters.car-filters').addClass('active');
				$navigations.addClass('animate');
				$navigations.addClass('sub');
				userFilters = 'car';
			}
		});

		$('.filters.car-filters .back').bind('touchstart touchend touchmove click', function(e){
			e.preventDefault();
			$('.navigations').removeClass('sub');
			$('.navigation-sub-level').show();
			$('.navigation-last-level').show();
			$('.filters.car-filters').removeClass('active');
		});

		//Show tyresearch
		$('.navigation .tyresearch').on('click', 'a', function(e){
			if (!searchPage && windowWidth > 480) {

			} else {
				e.preventDefault();
				$('.filters.tyre-filters').addClass('active');
				$('.navigation-last-level').hide();
				$navigations.addClass('animate');
				$navigations.addClass('show-tyres');
				userFilters = 'tyre';
			}
		});

		$('.filters.tyre-filters .back').bind('touchstart touchend touchmove click', function(e){
			e.preventDefault();

			$navigations.addClass('animate');
			$navigations.removeClass('show-tyres');
			$('.navigation-sub-level').show();
			$('.navigation-last-level').show();
			$('.filters.tyre-filters').removeClass('active');
		});

		if ( typeof document.location.href.split('#')[1] !== "undefined" && document.location.href.split('#')[1].indexOf('megasearch') != -1 ) {
			navigation.toggle('#megasearch', $('li.megasearch a'));
		}
	};

	if (document.body.classList.contains('car-search')) {
		const navigationSection = document.getElementById('navigation');
		let shouldCloseNav = false;

		document.documentElement.addEventListener('click', function(event) {
			if (window.innerWidth <= 639 && navigationSection && navigationSection.classList.contains('active')) {
				if (shouldCloseNav) {
					let currentParent = event.target.parentNode;

					while (currentParent && currentParent !== document) {
						if (currentParent === navigationSection) {
							break;
						}
						else {
							currentParent = currentParent.parentNode;
						}
					}

					if (currentParent === document) {
						event.preventDefault();
						navigation.toggle('#navigation', $('li.navigation a'));
						shouldCloseNav = false;
					}
				}
				else {
					shouldCloseNav = true;
				}
			}
			else if (shouldCloseNav) {
				shouldCloseNav = false;
			}
		});
	}

	return nav;

})();


$(function(){
    branchBar.init();
	navigation.init();
	search.init();
	accordions.init();

	//frontpage articles carousel
	var $articlesCarousel = $('.articles-carousel');
	if($articlesCarousel.length > 0){
		$articlesCarousel.cycle({
			timeout : 7000,
			slides : ".slide",
			fx : "carousel",
			carouselVisible : 1,
			carouselFluid : true
		});
	}

	if($('.autosalpa-60-vuotta').length){
		$(window).stellar({positionProperty: 'transform',hideDistantElements: false});
	}

	var club_carousel = $('.club-carousel');
	if(club_carousel.length > 0){
		$('.club-carousel').cycle({
			slides: ".slide",
			pagerTemplate: "<span></span>"
		});
		$('.club-carousel').find('.cycle-pager span').append('<span class="meter"></span>');
		$('nav .navigation a').click(function(){
					$('.club-carousel').cycle({
						reinit: true,
			slides: "p",
			pagerTemplate: "<span></span>"
		});
		});
	}

	var $offerCarousel = $('.offer-carousel .carousel-container');
	if($offerCarousel.length > 0){
		var slideAmount = 4;
		if($(window).width() < 1160 && $(window).width() > 900){
			slideAmount = 3;
		} else if($(window).width() <= 900 && $(window).width() > 768){
			slideAmount = 2;
		} else if($(window).width() <= 768){
			slideAmount = 1;
		}
		$offerCarousel.cycle({
			timeout : 2000,
			slides : ".slide",
			fx : "carousel",
			carouselVisible : slideAmount,
			carouselFluid : true,
			next : ".cycle-next",
			prev : ".cycle-prev"
		});
	}

	/*var club_section = $('.club-section');
	if(club_section.length){
		club_section.each(function(){
			var height = $(this).outerHeight();
			if(!$(this).hasClass('yellow'))
				$(this).find('.grid-1.img div').css({minHeight:height});
		})
	}*/

	if($('.login-form').length){
		$('.login-form form a.loginbutton').click(function(){
			$(this).prev('button').click();
		});
	}

	$('.timeline .show-full').click(function(ev){
		ev.preventDefault();
		$(this).parent().css({height: 'auto'}).find('.shader, .show-full').remove();
		//$(this).remove();
	});

	//login gum
	$('form.stage-extranet').submit( function(e) {
        //e.preventDefault();
        var $username = $(this).find('input[name=username]');
        var usernameVal = $username.val() != '' ? $username.val().toLowerCase() : $username.val();
        $username.val( usernameVal );
    });

	if($('#testdrives .td-item').length){
		setTimeout(function(){
			$('#testdrives .td-item').slice(7).fadeOut();
			if($('#testdrives .td-item').length > 7 && $('#testdrives .td-item').length != 0){
				$('#testdrives .td-item').last().after('<div class="grid-fourth text-center td-show-more"><h3>Näytä lisää</h3></div>');
			}
			$('#testdrives .td-show-more').click(function(){
                /*$('#testdrives .td-item:hidden').slice(0,4).fadeIn();*/ // Show 4 more
                if($('#FilterSelect').val() != 'all'){
                	$('#testdrives .td-item:hidden').hasClass($('#FilterSelect').val()).fadeIn();
                } else {
                	$('#testdrives .td-item:hidden').fadeIn();
                }
                if($('#testdrives .td-item:hidden').length < 1) {
                	$('.td-show-more').hide();
                }
            });
		}, 1000);
	}

	if($('#testrepairs .td-item').length){
		setTimeout(function(){
			$('#testrepairs .td-item').slice(7).fadeOut();
			if($('#testrepairs .td-item').length > 7 && $('#testrepairs .td-item').length != 0){
				$('#testrepairs .td-item').last().after('<div class="grid-fourth text-center td-show-more"><h3>Näytä lisää</h3></div>');
			}
			$('#testrepairs .td-show-more').click(function(){
                /*$('#testrepairs .td-item:hidden').slice(0,4).fadeIn();*/ // Show 4 more
                if($('#repairsFilterSelect').val() != 'all'){
                	$('#testrepairs .td-item:hidden').hasClass($('#repairsFilterSelect').val()).fadeIn();
                } else {
                	$('#testrepairs .td-item:hidden').fadeIn();
                }
                if($('#testrepairs .td-item:hidden').length < 1) {
                	$('.td-show-more').hide();
                }
            });
		}, 1000);
	}

	$('#add-more-image').click(function(){
		let counter = 0
		while ($(`#images_${counter}`).length){
			counter++;
		}
		$(`#images_${counter - 1}`).after(`<input type="file" style="line-height:1" id="images_${counter}" name="images_${counter}" accept="image/*" multiple>`)

	});

	function matchHeight(){
		var highestBox = 0;
		$('.matchHeight').each(function(){
			if($(this).children().height() > highestBox){
				highestBox = $(this).children().height();
			}
		});
		$('.matchHeight').height(highestBox);
	}
	matchHeight();

	function matchHeightLiftImg(){
    var highestBox = 0;
		$('.matchHeightLiftImg').each(function(){
			if($(this).children('img').height() > highestBox){
				highestBox = $(this).children('img').height();
			}
		});
		$('.matchHeightLiftImg').height(highestBox);
	}
	matchHeightLiftImg();

	setTimeout(function(){
		matchHeight();
		if($('.matchHeightLiftImg').height() == 0) {
			matchHeightLiftImg();
		}
	}, 2000);

	$('img').ready(function(){
		matchHeight();
		matchHeightLiftImg();
	});

	$(window).resize(function(){
		matchHeightLiftImg();
	});

	$(document).ready(function() {
		matchHeight();
		matchHeightLiftImg();
	});

	$('.TalkNow input[type=text][name=phone]').attr('placeholder', 'puhelinnumerosi');
	$(':input.phone[type=number]').on('mousewheel', function(e){
		e.preventDefault();
	});

	$('.TalkNow form button[type=submit]').attr('disabled', true).css('cursor', 'default');

	$('.TalkNow input[type=text][name=phone]').on('input', function(){
		if($(this).val().length > 0 && $.isNumeric($(this).val())) {
			$(this).parent().parent().find('.btn').removeAttr('disabled').css('cursor', 'pointer');
			$(this).parent().parent().find('.pop').hide();
		} else if($(this).val().length > 0 && !$.isNumeric($(this).val())) {
			$(this).parent().parent().find('.popup').html('Puhelinnumero&nbsp;voi&nbsp;sisältää&nbsp;vain&nbsp;numeroita');
			$(this).parent().parent().find('.btn').attr('disabled', true).css('cursor', 'default');
			$(this).parent().parent().find('.pop').show();
		} else {
			$(this).parent().parent().find('.popup').html('Kirjoita&nbsp;puhelinnumerosi&nbsp;numerokenttään ennen&nbsp;lomakkeen&nbsp;lähettämistä');
			$(this).parent().parent().find('.btn').attr('disabled', true).css('cursor', 'default');
			$(this).parent().parent().find('.pop').show();
		}
	});


	// Form placeholders
	var $formPlaceholders = $('.stage-form.md input, .stage-form.md textarea');
	$formPlaceholders.each(function() {
		if($(this).val()){
			$(this).parent().children('label').addClass('active');
		}
	});
	$formPlaceholders.focusin(function() {
		$(this).parent().children('label').addClass('active');
	});
	$formPlaceholders.focusout(function() {
		if(!$(this).val()){
			$(this).parent().children('label').removeClass('active');
		}
	});

    //Car finance calculator
    if ($('.finance_calculator').length > 0) {
    	financeCalculator.calcFinance();
		//var financeToggler = crasToggler($('.show_financial_statement'), $('.finance-popup'));
	}

	$('.finance_calculator select').on('change', function() {
		financeCalculator.calcFinance();
	});

	$('.finance_calculator input[type=number], .finance-popup input[type=number]').on('input', function() {
		financeCalculator.calcFinance();
	});

	//Car card list toggles
	$( ".show-less, .show-all" ).on( "click", function() {
		var $elem = $(this);
		var openEle = $elem.attr('data-show');
		var $openEle = null;
		if(typeof openEle !== 'undefined') {
			console.log('from data-show');
			$openEle = $('#' +openEle);
		} else {
			$openEle =  $elem.closest('.toggle-element');
		}
		$openEle.slideToggle();
		$elem.children('.show, .hide').toggle();
		return false;
	});

	$( ".toggle-listing" ).on( "click", function() {
		var $elem = $(this);
		var $parent = $elem.closest('ul');
		$parent.toggleClass('open');
		$elem.children('.closed-text, .open-text').slideToggle();
	});



	// Accept club conditions
	$('.accept-family-conditions').click(function(){
		if ($('#accept-family-conditions').is(':checked')) {
			$.get('/stage-ajax/acceptFamilyConditions?id='+$(this).data('uuid'));
			$(this).closest('.md-modal').fadeOut('fast').next('.md-overlay').fadeOut('fast');
		}
	});
	// Enable/disable accept button when accept checkbox is checked/unchecked
	$('#accept-family-conditions').change(function(){
		$('.accept-family-conditions').prop('disabled', !$(this).prop('checked'));
	});

//Frontpage
(function(){

	$('a.select-option').click(function(e){
		e.preventDefault();
		$(this).next().slideToggle();
	});

	$('.service-locations ul.locations ul li').on('click', 'a', function(e){
		e.preventDefault();
		var store = $(this).data('store');
		showClosestLocation = false;
		$('.store.loading-closest').remove();
        //$('.service-locations ul.locations ul').slideToggle(200);
        $(this).parent().parent().parent().parent().parent().find('ul.locations ul').slideToggle(200);
        $('.store').css('opacity', 0);
        setTimeout(function(){
        	$('.store.active').removeClass('active');
        	$('.store.'+store).addClass('active');
        	setTimeout(function(){
        		$('.store.'+store).css('opacity', 1);
        	}, 100);
        }, 100);
    });


})();

$('.store.active').css('opacity', 1);
if($('.popup-container').length){
	$('.pop').click(function(){
		var $elem = $(this);
		$elem.parent().parent().parent().find('.popup-container span').css('display','block');
		var popupChars = $elem.parent().parent().parent().find('.popup-container span').text().length;
		timeoutDelay = 3000+popupChars*50/2;
		setTimeout(function(){
			$elem.parent().parent().parent().find('.popup-container span').css('max-width','500px');
			$elem.parent().parent().parent().find('.popup-container span').css('max-height','200px');
			$elem.parent().parent().parent().find('.popup-container span').css('padding','4px 6px 3px');
		}, 1);
		setTimeout(function(){
			setTimeout(function(){
				$elem.parent().parent().parent().find('.popup-container span').css('max-width', '0');
				$elem.parent().parent().parent().find('.popup-container span').css('max-height', '0');
				$elem.parent().parent().parent().find('.popup-container span').css('padding','0 6px 0');
			}, 350);
			$elem.parent().parent().parent().find('.popup-container span').fadeOut('slow');
		}, timeoutDelay);
	});

    	// Open popup also on hover
    	$('.pop, .popup-container').hover(function(){
    		$('.popup-container').addClass('popup-open');
    	}, function(){
    		setTimeout(function(){
    			if ($('.pop:hover, .popup-container:hover').length === 0) {
    				$('.popup-container').removeClass('popup-open');
    			}
    		}, 350);
    	});
    }

    $('a.login').click(function(e){
    	e.preventDefault();
    	$(this).hide();
    	$('.login-form').show();
    });

    $('.club-member-info form.modify-user-info input').attr('disabled', 'disabled');

    $('.modify-info').click(function(e) {
    	e.preventDefault();
    	$('.club-member-info form').toggleClass('active');
    	$('.club-member-info form input').removeAttr('disabled');
    	$(this).hide();
    });

    $('.club-member-info form.modify-user-info').submit(function(e) {
    	e.preventDefault();

    	var $form = $(this), formData = $form.serialize();

    	$.ajax({
    		'url' : '/stage-ajax/saveUserInfo',
    		'data' : formData,
    		'success' : function(data){
    			if ( typeof data.errors !== "undefined" ) {
    				alert( data.errors.message );
    			} else {
    				$form.toggleClass('active');
    				$('.modify-info').show();
    				$('.club-member-info form.modify-user-info input').attr('disabled', 'disabled');
    			}
    		},
    		'complete' : function(data){
    		},
    		'error' : function(){}
    	});

    });

    $('#testdrives').mixItUp();

    var $filterSelect = $('#FilterSelect'), $container = $('#testdrives');
    $container.mixItUp();
    $('#FilterSelect').on('change', function () {
    	$('#testdrives').mixItUp('filter', this.value);
    	if($('#testdrives .td-item'+$(this).val()).length < 8) {
    		$('.td-show-more').hide();
    	}
    });

    $('#testrepairs').mixItUp();

    var $repairsFilterSelect = $('#repairsFilterSelect'), $repairsContainer = $('#testrepairs');
    $repairsContainer.mixItUp();
    $('#repairsFilterSelect').on('change', function () {
    	$('#testrepairs').mixItUp('filter', this.value);
    	if($('#testrepairs .td-item'+$(this).val()).length < 8) {
    		$('.td-show-more').hide();
    	}
    });

});

$(document).ready(function(){
    $('.matchHeightCampaign').matchHeight();

    $('.campaign-page .timeline .event .text a').click(function(e){
    	e.preventDefault();
    	$('.campaign-page .timeline .event .text .popup').fadeOut(200);
    	$(this).siblings('.popup').fadeIn(200);
    });

    $('.popup .modalClose').click(function() {
		$(this).parent().fadeOut(200);
	});

    $(document).click(function() {
		$('.campaign-page .timeline .event .text .popup').fadeOut(200);
	});

    $('.campaign-page .timeline .event .text .popup, .campaign-page .timeline .event .text a').click(function(e) {
		e.stopPropagation();
	});

    // Expand campaign page brand content box
    $('.campaign-brand-container .read-more').click(function(){
        var $self = $(this);
        $self.siblings('.brand-text-container').slideToggle();
        $self.parent().toggleClass('active');
    });
});

/* Simple Image Gallery Functions */
$(document).ready(function(){
	if($('.SIG').length){
		String.prototype.getImgWidth = function() {
			var img = new Image();
			img.src = this;
			return img.width;
		};

		var SIGModal = '<div class="SIGModal" style="display:none;"><div class="table"><div class="vMid"><div class="SIGModalContainer"><div class="SIGModalClose"></div><div class="SIGModalInnercontainer"><img src="" /><span class="SIGModalCaption"></span></div></div></div></div></div>';
		$('body').append(SIGModal);

		$('.SIGModal, .SIGModalClose').click(function(){
				$('.SIGModal').fadeOut(200, function(){
						$('.SIGModal').find('.SIGModalImg').attr('src', '');
						$('.SIGModal').find('.SIGModalCaption').html('');
						$('.SIGModalContainer').css('max-width', 900);
				});
		});

		$(".SIGModal .SIGModalContainer").click(function(e) {
				e.stopPropagation();
		});
	}

    // Open
	var hash = document.location.hash ? document.location.hash : false;
	if(hash && $('.SIG').length){
		var $self = $(hash);
		var url = $self.data('src');
		var author = $self.data('author');
		var caption = $self.data('caption');
		var img_width = $self.data('src').getImgWidth();
		$('.SIGModal').find('.SIGModalContainer img').attr('src', url);
		$('.SIGModal').find('.SIGModalContainer .SIGModalCaption').html(caption+'<div class="SIGModalAuthor">- '+author+'</div>');
		$('.SIGModalContainer').css('max-width', img_width);
		$('.SIGModal').fadeIn(200);
	}

	$('.SIGitem').click(function(){
			var $self = $(this);
			var id = $self.prop('id');
			var url = $self.data('src');
			var author = $self.data('author');
			var caption = $self.data('caption');
			var img_width = $self.data('src').getImgWidth();
			$('.SIGModal').find('.SIGModalContainer img').attr('src', url);
			$('.SIGModal').find('.SIGModalContainer .SIGModalCaption').html(caption+'<div class="SIGModalAuthor">- '+author+'</div>');
			if(img_width > 0){
				$('.SIGModalContainer').css('max-width', img_width);
		}
			$('.SIGModal').fadeIn(200);
	});

	$('.retailer-staff .contact').matchHeight();
	$('.interest-offer .matchHeightOffer').matchHeight();
	$('.SIGitem').matchHeight();
});

function storeContactEvent(type,phoneNum,callback){
//	console.log(type,phoneNum);
	if( typeof type == 'undefined' || !type ) return;
	var carUuidEl = $('section[data-uuid]:first'),
		carUuid = false,
		wtf = false;

	if( carUuidEl.length && carUuidEl.attr('data-uuid') ) {
		carUuid = carUuidEl.attr('data-uuid');
		if( carUuidEl.attr('data-wtf') ) wtf = carUuidEl.attr('data-wtf');
	}

	var params = {
		lead_type: type,
		link: document.location.href
	};
	if( carUuid ) params.car_uuid = carUuid;
	if( wtf ) params.wtf = wtf;
	if( typeof phoneNum != 'undefined' && phoneNum ) params.phone = phoneNum;
	$.ajax({
		url: '/stage-ajax/new_contact/',
		type: 'POST',
		data: params,
    complete: function(){
      if( typeof callback == 'function' ) callback();
    }
	});
}

function getPhoneNum(){
	var phoneNum = $('#talkNowActivePhone').val();
	if( phoneNum ) {
		storeContactEvent('phone-number-submit',phoneNum);
	}
}

function closePopup(e){
	document.getElementById('cover-page').classList.remove('show');
	document.querySelector('.autosalpa-popup').classList.remove('show');
}

if (document.querySelector('main.campaign-page.autosalpa-sopimus')) {

    var animatedTexts = [
        'Ei suurta ensimmäistä erää',
        'Ei huolta auton jälleenmyyntiarvosta',
        'Taattu takaisinostohinta',
        'Kiinteä kuukausierä',
        'Laadukas auto ilman sidottua pääomaa'
    ];
    var currentTextElement;
    var textAnimationCounter = 1;
    var animatedTextHolder;

	initializeAnimatedText(animatedTexts);
	var textAnimationInterval = setInterval(changeText, 5000);
}

if (document.querySelector('[data-action="closePopup"]')) {
    var closePopupActions = document.querySelectorAll('[data-action="closePopup"]');
    for(var i=0;i<closePopupActions.length;i++) {
				closePopupActions[i].addEventListener('click', closePopup);
    }
}

/* Autosalpa Sopimus campaign animated text */
function initializeAnimatedText() {
		animatedTextHolder = document.createElement('div');
		animatedTextHolder.classList.add('animated-text');

		var el = document.createElement('p');
		el.appendChild(document.createTextNode(animatedTexts[0]));
		animatedTextHolder.appendChild(el);

		currentTextElement = el;
		var headerText = document.querySelector('.campaign-top-bar .header-container');
		headerText.insertBefore(animatedTextHolder, headerText.querySelector('span.bottomline'));
}

function changeText(i) {
		if (textAnimationCounter == animatedTexts.length) {
				textAnimationCounter=0;
		}

		currentTextElement.parentElement.removeChild(currentTextElement);

		var el = document.createElement('p');
		el.appendChild(document.createTextNode(animatedTexts[textAnimationCounter]));
		animatedTextHolder.appendChild(el);

		currentTextElement = el;

		textAnimationCounter++;
}

// product page click tracking
$(document).ready(function(){
	var path = window.location.pathname.split('/');
	var page = path[path.length - 1] === '' ? path[path.length - 1] : path[path.length - 2];
	if(document.getElementById('recruitment-form')) {

        function initJumpToYearSelects() {
            var jumpToYearSelects = document.getElementsByClassName('jump-to-year');
            for (var i = 0; i < jumpToYearSelects.length; i++) {
                jumpToYearSelects[i].addEventListener('input', function() {
                    document.getElementById(this.dataset.dateInput).value = this.value+'-01-01';
                });
            }
        }


        var experienceId = 0,
			educationId  = 0,
		    experienceTemplate = document.getElementById('experience').innerHTML,
			educationTemplate  = document.getElementById('education').innerHTML;

		document.getElementById('add-experience').addEventListener('click', function() {
			experienceId++;
            var rendered = Mustache.render(experienceTemplate, {'experienceId' : experienceId});
			document.getElementById('experience-container').insertAdjacentHTML('beforeend', rendered);
            initJumpToYearSelects();
		});
        document.getElementById('add-education').addEventListener('click', function() {
			educationId++;
            var rendered = Mustache.render(educationTemplate, {'educationId' : educationId});
            document.getElementById('education-container').insertAdjacentHTML('beforeend', rendered);
            initJumpToYearSelects();
        });

        /* remove event for elements above with a neat trick */

		document.getElementById('experience-container').addEventListener('click', function(e) {
			if (e.target.classList.contains('remove-form-element')) {
				e.target.parentElement.remove();
			}
		});
        document.getElementById('education-container').addEventListener('click', function(e) {
            if (e.target.classList.contains('remove-form-element')) {
                e.target.parentElement.remove();
            }
        });

        initJumpToYearSelects();

	}

	if( $('section[data-uuid].carCard').length ) {
        $(document).on('submit', '#talkNowActive form', function (e) {
            getPhoneNum();
        }).on('click', '#talkNowActive .lekanebutton', function (e) {
					dataLayer.push({
						event: 'GAEvent',
						eventCategory: 'CarPage talkNowActive lekanebutton',
						eventAction: 'click',
						eventLabel: 'talkNowActive lekanebutton - clicked',
						nonInteraction: false
					});
            getPhoneNum();
        }).on('click', '.contact-person a', function (e) {
            e.preventDefault();
            var link = $(this).attr('data-target') ? $(this).attr('data-target') : $(this).text(),
                target = $(this).attr('href');
            var callback = target && target != '#' ? function () {
                window.location.href = target;
            } : undefined;
            storeContactEvent(link, undefined, callback);
        });
    }

});

if (document.querySelector('.autosalpa-slideshow')) {
	var slideshow = {
		init : function() {
			slideshow.prevButton.addEventListener('click', slideshow.prev);
							slideshow.nextButton.addEventListener('click', slideshow.next);
		},
		next : function() {
			if (slideshow.slidePosition === slideshow.slidesCount-1) {
				slideshow.slidePosition = 0;
			} else {
				slideshow.slidePosition++;
			}
			slideshow.updateSlidePosition();
		},
		prev : function() {
			if (slideshow.slidePosition === 0) {
				slideshow.slidePosition = slideshow.slidesCount-1;
			} else {
				slideshow.slidePosition--;
			}
			slideshow.updateSlidePosition();
		},
		updateSlidePosition : function() {
			slideshow.reel.style.left = -(slideshow.slidePosition*100)+'%';
			slideshow.caption.innerHTML = slideshow.slidePosition+1 + ' / ' + slideshow.slidesCount;

		},
		reel          : document.querySelector('.autosalpa-slideshow-reel'),
		prevButton    : document.querySelector('.autosalpa-slideshow > .controls > .prev'),
		nextButton    : document.querySelector('.autosalpa-slideshow > .controls > .next'),
		caption       : document.querySelector('.autosalpa-slideshow > .controls > .cycle-caption'),
		slidesCount   : document.querySelectorAll('.autosalpa-slideshow-reel > .slide').length,
		slidePosition : 0
	};
			slideshow.init();
}

window.onload = function() {
	// Contact form - hide 'huolto' from subjects dropdown when selected vaihtoautosalpa
	if(document.getElementById('contact-request-form')) {
		var serviceOption = document.getElementById('subject').querySelector('option[value="huolto"]');
		document.getElementById('toimipiste').addEventListener('change', function(event) {
			if(event.target.value === '89DfFEhBQyCyKaoB5tBhzQ' || event.target.value === 'b4_wNVyLTtmtWaxiqTaVoA') {
				serviceOption.disabled = true;
				serviceOption.innerText = 'Huolto (ei saatavilla)';
				document.getElementById('subject').value = 'automyynti';
			} else {
				serviceOption.disabled = false;
				serviceOption.innerText = 'Huolto';
			}
		});
	}
};
$(document).ready(function() {
  // on Request of task https://3.basecamp.com/3360800/buckets/4840992/todos/1551563610
  const addAdPixel = () => {
    const imgPixel = document.querySelector('img[src=" https://secure.adnxs.com/seg?add=16753212&t=2 "]');
    if (imgPixel === null) {
      const adPixel = `
<! - Segment Pixel - 1905-06 Autosalpa Oy Clio on campaign pages retargeting_1x1 - DO NOT MODIFY ->
<img src = " https://secure.adnxs.com/seg?add=16753212&t=2 " width = " 1 "height =" 1 "/>
<! - End of Segment Pixel ->`;
      document.querySelector('footer').innerHTML += adPixel;
    }
  };

  const searchSlug = window.location.search;
  if (searchSlug.indexOf('renault') !== -1 || searchSlug.indexOf('clio') !== -1) {
    addAdPixel();
  }

  const filter = document.querySelector('.filters.car-filters');
  if(filter!==null){
    filter.addEventListener('click', () => {
      const renaultOption = document.querySelector('a[data-filter-option="renault"]');
      const clioOption = document.querySelector('a[data-filter-option="clio"]');

      [renaultOption, clioOption].forEach(div => {
        if (div !== null) {
          div.addEventListener('click', () => {
            addAdPixel();
          });
        }
      });
    });
  }
});

const contactMenuButton = document.getElementById('contact-menu-open');

if (contactMenuButton) {
	const navigationEl = document.getElementById('navigation');

	contactMenuButton.addEventListener('click', function(event) {
		$('.navigation-sub-level').show();
		$('.navigation-last-level').show();
		navigation.toggle('#navigation', $('li.navigation a'));
		const currentlyActive   = navigationEl.getElementsByClassName('active');
		for (let i = 0; i < currentlyActive.length; i++) {
			currentlyActive[i].classList.remove('active');
		}
		if (navigationEl.querySelector('.last')) {
			navigationEl.querySelector('.last').classList.remove('last');
		}
		if (navigationEl.querySelector('.sub')) {
			navigationEl.querySelector('.sub').classList.remove('sub');
		}

		navigationEl.querySelector('a[data-page-class="yhteystiedot"]').click();
	});
}
